<template>
  <div class="action-popover-wrapper" ref="popoverWrapper">
    <VIcon @click="togglePopover" style="cursor: pointer" name="more-vertical-line" class="popoverIcon"></VIcon>
    <div v-if="popoverOpen" class="action-popover" :class="[side, alignment]" :style="popoverStyle">
      <div class="action-popover-content" @click="handleContentClick">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      popoverOpen: false,
    };
  },
  props: {
    // eg. :style="{'--width': '170px'}"
    style: {
      type: Object,
      default: () => {
        return {};
      },
    },
    side: {
      type: String,
      default: "left",
    },
    alignment: {
      type: String,
      default: "start",
    },
    dismissOnSelect: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    popoverStyle() {
      const styles = {};
      if (this.style && this.style['--width']) {
        styles.width = this.style['--width'];
      }
      return styles;
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    togglePopover() {
      this.popoverOpen = !this.popoverOpen;
    },
    handleContentClick() {
      if (this.dismissOnSelect) {
        this.popoverOpen = false;
      }
    },
    handleOutsideClick(e) {
      if (this.popoverOpen && this.$refs.popoverWrapper && !this.$refs.popoverWrapper.contains(e.target)) {
        this.popoverOpen = false;
      }
    }
  },
};
</script>

<style scoped>
.action-popover-wrapper {
  position: relative;
  display: inline-block;
}

.action-popover {
  position: absolute;
  top: 100%;
  z-index: 1000;
  background: var(--white);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  min-width: 150px;
  overflow: hidden;
  animation: popoverFadeIn 0.15s ease-out;
}

/* Side positioning */
.action-popover.left {
  right: 0;
}
.action-popover.right {
  left: 0;
}

/* Alignment */
.action-popover.start {
  margin-top: 4px;
}
.action-popover.end {
  bottom: 100%;
  top: auto;
  margin-bottom: 4px;
}

.action-popover-content {
  padding: 0;
}

@keyframes popoverFadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
